export const state = {
    message: null,
    errors: null,
    success: null
}

// getters
export const getters = {
    message: state => state.message,
    errors: state => state.errors,
    success: state => state.success,
}

// mutations
export const mutations = {
    setMessage(state, message) {
        state.message = message
    },
    setErrors(state, errors) {
        state.errors = errors
    },
    setSuccess(state, success) {
        state.success = success
    },
}

// actions
export const actions = {
    clearNotifications({commit}) {
        commit('setMessage', null)
        // commit('setErrors', null)
        commit('setSuccess', null)
    }
}
